/**
 * jQuery Unveil
 * A very lightweight jQuery plugin to lazy load images
 * http://luis-almeida.github.com/unveil
 *
 * Licensed under the MIT license.
 * Copyright 2013 Luís Almeida
 * https://github.com/luis-almeida
 */

;(function($) {

  $.fn.unveil = function(threshold, callback) {


	  
    var $w = $(window),
        th = threshold || 0,
        images = this,
        loaded;

    this.one("unveil", function() {
      var source = this.getAttribute('data-swap');
      if (source) {
       this.setAttribute("data-interchange", this.getAttribute('data-swap'));
		 this.setAttribute('data-swap','');
		 var elem = new Foundation.Interchange($(this));
        if (typeof callback === "function") callback.call(this);
      }
    });

    function unveil() {
      var inview = images.filter(function() {
        var $e = $(this);
        if ($e.is(":hidden")) return;

        var wt = $w.scrollTop(),
            wb = wt + $w.height(),
            et = $e.offset().top,
            eb = et + $e.height();

        return eb >= wt - th && et <= wb + th;
      });

      loaded = inview.trigger("unveil");
      images = images.not(loaded);
    }

    $w.on("scroll.unveil resize.unveil lookup.unveil", unveil);

    unveil();

    return this;

  };

})(window.jQuery || window.Zepto);

// JavaScript Document
 $(document).ready(function () {

	$("*[data-swap]").unveil(100,function(){if(!$(this).hasClass('figure')){this.style.opacity = 1;}});
	$('body').on('open.zf.reveal',function(){$("*[data-swap]").unveil(100,function(){if(!$(this).hasClass('figure')){this.style.opacity = 1;}});});
	if($("*[data-accordion]").length){
	//_.delay(function(){Foundation.reInit(['accordion']);},500);
	$("*[data-accordion]").on('down.zf.accordion',function(t){$(window).trigger('lookup.unveil');});
	}
	if($("*[data-tabs]").length){
	$("*[data-tabs]").on('change.zf.tabs',function(t){$(window).trigger('lookup.unveil');})
	}
	 $(window).trigger('lookup.unveil');
	//if($("*[data-equalizer]").length){
	//_.delay(function(){Foundation.reInit(['equalizer']);},500);
	//}

});
